var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"id":_vm.name,"label":_vm.label,"label-for":_vm.name}},[_c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.selectValue),callback:function ($$v) {_vm.selectValue=$$v},expression:"selectValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }